import React, { useState } from 'react';
import { Collapse } from '@mui/material';

const SettingsSection = ({ title, children, defaultExpanded = false }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <>
      <div className="title" onClick={() => setExpanded((current) => !current)}>
        <h5>{title}</h5>
        <button type="button" className="btn text" aria-expanded={expanded}>
          <span className={expanded ? 'icon-minus' : 'icon-plus'}></span>
        </button>
      </div>
      <Collapse in={expanded}>{children}</Collapse>
    </>
  );
};

export default SettingsSection;
